import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

const SidebarInfo = ({ children }) => (
	<Stack
		sx={{
			flexDirection: 'column',
		}}
	>
		{children}
	</Stack>
);

SidebarInfo.propTypes = {
	children: PropTypes.any,
};

export default SidebarInfo;
